import { useMemo } from 'react';
import { CHECKOUT_URL } from '../data/site';
import { buildCheckoutUrl } from '../utils/checkoutUrl';

export function useCheckoutHref(): string {
  return useMemo(() => {
    if (typeof window === 'undefined') return CHECKOUT_URL;
    return buildCheckoutUrl(CHECKOUT_URL, window.location.search);
  }, []);
}

